module.exports = function () {
  return new Promise(function (resolve) {
    require.ensure([], function (require) {
      resolve(require("!!/Users/zakrisha/Rclone/dev/metabase/node_modules/babel-loader/lib/index.js??ruleSet[1].rules[0].use[0]!/Users/zakrisha/Rclone/dev/metabase/frontend/src/metabase/lib/ga-metadata.js"));
    });
  });
}